import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ae00d4c2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "nav-bar-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "category-name"
};
const _hoisted_4 = ["extInfo"];

const _hoisted_5 = /*#__PURE__*/_createTextVNode("APP");

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = ["extInfo"];

const _hoisted_8 = /*#__PURE__*/_createTextVNode("APP");

const _hoisted_9 = [_hoisted_8];
import { computed } from 'vue';
import composition from '@/composition';
import ua from '@/utils/platform';
import { copyTextToClipboard } from '@/utils/regular';
export default {
  props: {
    categories: Array,
    model: Object
  },

  setup(__props) {
    const props = __props;
    const showItem = computed(() => {
      if (props.categories && props.categories.length > 0) {
        return props.categories[0];
      } else {
        return 0;
      }
    });

    function clickOpenApp() {
      if (ua.isMini) {
        copyTextToClipboard(location.href);
        alert('链接复制成功，请您分享给朋友。');
        return;
      }

      if (props.model) {
        openApp();
      } else {
        // 跳转到首页
        openApp(null, true);
      }
    }

    const {
      openApp,
      getAppSearch
    } = composition(); // const weapp_username = ref('gh_c0321ea144e0')
    // const weapp_path = ref('/packageNews/pages/index/index')

    return (_ctx, _cache) => {
      const _directive_wx_app = _resolveDirective("wx-app");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["nav-bar", {
          nobg: _unref(showItem)
        }])
      }, [_unref(showItem) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("img", {
        class: "category-img",
        src: _unref(showItem).icon,
        alt: ""
      }, null, 8, _hoisted_2), _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(showItem).name), 1), _unref(ua).isMini ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "open-btn big",
        onClick: _cache[0] || (_cache[0] = $event => clickOpenApp())
      }, "复制分享链接")) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(ua).isAndroid ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["open-btn", [_unref(ua).isWeixin ? '' : 'left']]),
        elId: "launchAppTip",
        appid: "wx27352935c18b925d",
        extInfo: _unref(getAppSearch)(null, !props.model)
      }, _hoisted_6, 10, _hoisted_4)), [[_directive_wx_app]]) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["open-btn", [_unref(ua).isWeixin ? '' : 'left']]),
        onClick: _cache[1] || (_cache[1] = $event => clickOpenApp())
      }, "APP", 2))], 64))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(ua).isMini ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "open-btn big",
        onClick: _cache[2] || (_cache[2] = $event => clickOpenApp())
      }, "复制分享链接")) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(ua).isAndroid ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["open-btn", [_unref(ua).isWeixin ? '' : 'left']]),
        elId: "launchAppTip",
        appid: "wx27352935c18b925d",
        extInfo: _unref(getAppSearch)(null, !props.model)
      }, _hoisted_9, 10, _hoisted_7)), [[_directive_wx_app]]) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["open-btn", [_unref(ua).isWeixin ? '' : 'left']]),
        onClick: _cache[3] || (_cache[3] = $event => clickOpenApp())
      }, "APP", 2))], 64))], 64))], 2)]);
    };
  }

};